/* eslint-disable require-jsdoc */
import { AxiosStatic } from 'axios';

export default class ScheduleService {
    axios;
    constructor(axios: AxiosStatic, domain) {
        this.axios = axios;
        this.domain = domain;
    }

    async createMeetingSchedule(data) {
        await this.axios.post('/meeting_schedule', {
            meetingName: data.name,
            startDate: data.startTime,
            endDate: data.endTime,
            invitedUsers: data.invitedUsers,
            timeZone: data.timeZoneValue
        });
    }
    async updateMeetingSchedule(meetingId, data) {
        await this.axios.put(`/meeting_schedule/${meetingId}`, {
            meetingName: data.name,
            startDate: data.startTime,
            endDate: data.endTime,
            invitedUsers: data.invitedUsers,
            timeZone: data.timeZoneValue,
            meetingOwner: data.meetingOwner
        });
    }
    async deleteMeetingSchedule(meetingId) {
        const deleteMeeting = await this.axios.delete(`/meeting_schedule/${meetingId}`);

        return deleteMeeting.data;
    }

    async getMyMeetings() {
        const meetings = await this.axios.get('/meeting_schedule/my');

        return meetings.data;
    }
}
